(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', async (e) => {
      const button = e.target.closest('.add-to-cart-button');
      if (!button) return;

      e.preventDefault();

      const variantId = parseInt(button.getAttribute('data-variant-id'), 10);

      if (!variantId) {
        console.error('Invalid variant ID');
        return;
      }

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!addResponse.ok) {
          const errorData = await addResponse.json();
          throw new Error(errorData.message || 'Failed to add item to cart.');
        }

        console.log('Product successfully added to cart.');

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && !cartDrawer.hasAttribute('open')) {
          cartDrawer.setAttribute('open', '');
        }

        const sectionResponse = await fetch("/?sections=cart-drawer,cart-icon-bubble");
        const sections = await sectionResponse.json();

        if (cartDrawer && typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents({
            sections: sections
          });
          cartDrawer.classList.remove("is-empty");
        }
      } catch (err) {
        console.error('Error adding to cart:', err.message || err);
        alert(err.message || 'Something went wrong. Please try again.');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-card-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', async (e) => {
      const button = e.target.closest('.add-to-cart-button');
      if (!button) return;

      e.preventDefault();

      const variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      const loader = button.querySelector('.custom_add_to_cart_loader');
      const content = button.querySelector('.button-content');

      if (!variantId) {
        console.error('Invalid variant ID');
        return;
      }

      try {
        if (loader) loader.style.display = 'inline-block';
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!addResponse.ok) {
          const errorData = await addResponse.json();
          throw new Error(errorData.message || 'Failed to add item to cart.');
        }

        console.log('Product successfully added to cart.');

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && !cartDrawer.hasAttribute('open')) {
          cartDrawer.setAttribute('open', '');
        }

        const sectionResponse = await fetch("/?sections=cart-drawer,cart-icon-bubble");
        const sections = await sectionResponse.json();

        if (cartDrawer && typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents({
            sections: sections
          });
          cartDrawer.classList.remove("is-empty");
        }
      } catch (err) {
        console.error('Error adding to cart:', err.message || err);
        alert(err.message || 'Something went wrong. Please try again.');
      } finally {
        if (loader) loader.style.display = 'none';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
